<template>
  <AppModalEdit
    v-model="isActive"
    :show-exec-button="false"
    :confirm-on-click-cancel="false"
    cancel-button-text="閉じる"
    title="期間限定マージン"
    width="40vw"
    min-height="36vh"
  >
    <v-container v-if="isActive" grid-list-md>
      <v-layout wrap>
        <v-flex xs2>
          <h4>マージン率</h4>
        </v-flex>
        <v-flex xs10>
          {{ item.marginPercent }}
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs2>
          <h4>使用可能期間</h4>
        </v-flex>
        <v-flex xs10>
          {{ item.dateRange }}
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs2>
          <h4>申請状況</h4>
        </v-flex>
        <v-flex xs10>
          {{ item.statusDisplayName }}
        </v-flex>
      </v-layout>
      <v-layout v-if="item.isRejected" wrap>
        <v-flex xs2>
          <h4>却下理由</h4>
        </v-flex>
        <v-flex xs10 style="white-space: pre-wrap">{{ item.reason }}</v-flex>
      </v-layout>
    </v-container>
  </AppModalEdit>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    isActive: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
}
</script>

<style scoped></style>
